import { DataTableCellFormatBaseValueConverter } from 'General/Resources/ValueConverters/DataTableCellFormatBase';

export class DataTableCellFormatValueConverter extends DataTableCellFormatBaseValueConverter {

}